import { useEffect, useState, useCallback } from 'react';
import maintenanceIllustration from '../assets/images/maintenance.svg';
import { publicEnv } from '../publicEnv';

const GATEWAY_URL =
  publicEnv('REACT_APP_BASE_URL_v2') ||
  'https://api.lms.v2.powerlearnprojectafrica.org/gateway/api';

const POLL_INTERVAL_MS = 30_000;
const TIMEOUT_MS = 8_000;

function MaintenanceBanner() {
  const [isDown, setIsDown] = useState(false);

  const checkHealth = useCallback(async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
    try {
      const res = await fetch(GATEWAY_URL, {
        method: 'GET',
        signal: controller.signal,
      });
      setIsDown(res.status >= 500);
    } catch {
      setIsDown(true);
    } finally {
      clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    checkHealth();
    const id = setInterval(checkHealth, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [checkHealth]);

  if (!isDown) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-md rounded-2xl bg-white px-8 py-10 text-center shadow-2xl">
        <img
          src={maintenanceIllustration}
          alt="System maintenance"
          className="mx-auto mb-6 h-44 w-44"
        />

        <h2 className="mb-3 text-2xl font-semibold text-mine-shaft-500">
          Scheduled Maintenance
        </h2>

        <p className="mb-2 text-sm leading-relaxed text-dove-500">
          We&rsquo;re currently improving your experience. Please don&rsquo;t
          worry &mdash; our engineering team is actively working on it.
        </p>

        <p className="text-xs text-dove-500/80">
          This banner will disappear automatically once services are restored.
        </p>

        <div className="mt-6 flex items-center justify-center gap-1.5">
          <span className="inline-block h-2 w-2 animate-bounce rounded-full bg-claret-500 [animation-delay:-0.3s]" />
          <span className="inline-block h-2 w-2 animate-bounce rounded-full bg-claret-500 [animation-delay:-0.15s]" />
          <span className="inline-block h-2 w-2 animate-bounce rounded-full bg-claret-500" />
        </div>
      </div>
    </div>
  );
}

export default MaintenanceBanner;
